import { UIData } from '../../hooks/stores/uiStore';

interface ElementEditingDependencies {
  UIData: UIData;
  setUIData: (data: Partial<UIData>) => void;
  updateElementData: (id: string, data: { [key: string]: any }, propertyPath?: string) => void;
}

export function createElementEditingUtils({
  UIData,
  setUIData,
  updateElementData,
}: ElementEditingDependencies) {
  const startEditingElement = (id: string) => {
    setUIData({ elementInEditingModeID: id });
  };

  const endEditingElement = (newTextValue?: string | null) => {
    if (newTextValue === null) {
      setUIData({ elementInEditingModeID: undefined });
      return;
    }
    const id = UIData.elementInEditingModeID;
    if (!id) return;
    updateElementData(id, { text: newTextValue }, 'props');
    setUIData({ elementInEditingModeID: undefined });
  };

  return {
    startEditingElement,
    endEditingElement,
  };
} 